import type VariableId from "../variables/VariableId";
import type FieldId from "../fields/FieldId";
import { isEqual, isNil } from "lodash-es";
import type { MetaVariableId } from "../metaVariables/metaVariable";

export abstract class ValueReference<T = FieldId | VariableId | MetaVariableId> {
  public readonly id: T;

  constructor(id: T) {
    this.id = id;
  }

  equals(other: this | string | undefined | null) {
    if (isNil(other)) {
      return false;
    }

    if (other instanceof this.constructor) {
      return isEqual(other, this);
    }

    return other === this.toString();
  }

  public abstract toString(): string;

  // JSON.stringify() uses this method to get the string representation
  public toJSON(): string {
    return this.toString();
  }
}
